export const BUTTON_SIZE_BORDER_RADIUS = {
  small: 8,
  medium: 10,
  large: 12
};
